(() => {
  const init = () => document.querySelectorAll('[data-calendar-preview]').forEach(card => {
    if (card.dataset.initialized) return;
    card.dataset.initialized = 'true';
    const number = card.querySelector('[data-week]');
    const progress = card.querySelector('[data-progress]');
    const dots = Array.from(card.querySelectorAll('.eth-week-dots i'));
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let week = 1, timer = null, visible = false, resetting = false;
    const draw = () => {
      number.textContent = week;
      progress.style.transform = `scaleX(${(week - 1) / 15})`;
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-lit', index < week);
        dot.classList.toggle('is-active', index === week - 1);
      });
    };
    const stop = () => { clearTimeout(timer); timer = null; card.classList.add('is-paused'); };
    const schedule = (delay = 1100) => {
      if (!visible || document.hidden || motion.matches) return stop();
      card.classList.remove('is-paused');
      timer = setTimeout(tick, delay);
    };
    const tick = () => {
      timer = null;
      if (week === 16 && !resetting) {
        resetting = true;
        card.classList.add('is-resetting');
        schedule(420);
        return;
      }
      if (resetting) {
        week = 1; draw();
        // Reset while the timeline is faded, then reveal a fresh cycle.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          resetting = false; card.classList.remove('is-resetting'); schedule();
        }));
        return;
      }
      week += 1; draw();
      number.classList.remove('is-changing');
      void number.offsetWidth;
      number.classList.add('is-changing');
      schedule();
    };
    const sync = () => {
      stop();
      if (motion.matches) {
        week = 1; resetting = false;
        card.classList.remove('is-resetting', 'is-changing');
        draw();
      } else schedule();
    };
    draw(); stop();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting; sync();
      }, { threshold: 0 }).observe(card);
    } else { visible = true; sync(); }
    document.addEventListener('visibilitychange', sync);
    motion.addEventListener('change', sync);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
